import {
  FormControl,
  FormHelperText,
  Grid,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { memo, useState } from "react";
import { isMobile } from "react-device-detect";
import thLocale from "date-fns/locale/th";
import enLocale from "date-fns/locale/en-US";
import EventIcon from "@mui/icons-material/Event";
import {
  formatterDate,
  formatterIdCard
} from "../../utils/formatter";
import { isEmpty } from "lodash";

//Libraries is Deprecated 16 Dec 2023
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
// import LocalizationProvider from "@mui/lab/LocalizationProvider";
// import DatePicker from "@mui/lab/DatePicker";

import DesktopDatePickerComponent from "../DesktopDatePickerComponent/DesktopDatePickerComponent";
import { getData } from "../../utils/GlobalHelper";

import DatePickerInput from "../../components/DatePickerMoblie/DatePickerInput";
import moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";

const useStyle = makeStyles({
  fontDB: {
    fontFamily: "DB Heavent !important",
  },
  fontNormal: {
    fontWeight: "normal !important",
  },
  textError: {
    fontSize: "16px !important",
    fontFamily: "DB Heavent !important",
    color: "var(--red) !important",
  },
  btnChild: {
    width: "100%",
    boxShadow: "1px 1px 4px 0px #ccc",
    margin: "14px 0px 0px 4px !important",
    color: "var(--primary) !important",
    fontWeight: "bold !important",
    "& svg": {
      position: "absolute",
      left: "12px",
      fontSize: "40px",
    },
  },
  typographyBtnCancel: {
    display: "flex",
    position: "relative",
    alignItems: "center",
    "& svg": {
      position: "absolute",
      right: "0px",
      color: "var(--red)",
      cursor: "pointer",
    },
  },
});
const ChildList = (props) => {
  const classes = useStyle();
  const { list, valid, handleChange } = props;
  const lang = getData("lang");
  const [childList, setChildList] = useState(list);
  const idc = getData("idc");
  const family_status = getData("family_status");
  const localeMap = {
    th: thLocale,
    en: enLocale,
  };
  const d = new Date();
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  const checkValidate = (val) => {
    return !val;
  };

  const checkCid = (cid) => {
    var total = 0;
    var iPID;
    var chk;
    var Validchk;
    iPID = cid.replace(/-/g, "");
    Validchk = iPID.substr(12, 1);
    var j = 0;
    var pidcut;
    for (var n = 0; n < 12; n++) {
      pidcut = parseInt(iPID.substr(j, 1));
      total = total + pidcut * (13 - n);
      j++;
    }

    chk = 11 - (total % 11);

    if (chk == 10) {
      chk = 0;
    } else if (chk == 11) {
      chk = 1;
    }
    if (chk == Validchk) {
      return true;
    } else {
      return false;
    }
  };
  const CardIdError = (val) => {
    if (!isEmpty(val)) {
      if (val.length < 13) {
        return "กรุณาระบุเลขที่บัตรประจำตัวประชาชน";
      } else {
        if (!checkCid(val)) {
          return "กรุณาระบุเลขที่บัตรประจำตัวประชาชนให้ถูกต้อง";
        } else {
          let check = 0;
          childList.forEach((element, i) => {
            if (element.cardId === val.replace(/[-]+/g, "")) check++;
          });
          if (
            val.replace(/[-]+/g, "") === idc?.idCard ||
            check > 1 ||
            val.replace(/[-]+/g, "") === family_status?.f1_spouse_id_card
          ) {
            return "เลขบัตรประจำตัวประชาชนไม่ถูกต้อง";
          }
        }
      }
    } else {
      return "กรุณาระบุเลขที่บัตรประจำตัวประชาชน";
    }
  };
  const formatName = (val) => {
    return val.replace(/[^a-zA-Zก-๏.\s\-]/g, "");
  };
  const cardIdChange = (val, i) => {
    val = val.replace(/[-]+/g, "").slice(0, 13);

    let isnum = /^\d+$/.test(val);
    let newArray = [...childList];
    let newVal = "";
    if (val.length === 13 && isnum) {
      newVal = val.replace(/[^0-9-]+/g, "");
    } else {
      newVal = val.replace(/[^0-9-]+/g, "");
    }

    newArray[i] = { ...newArray[i], cardId: newVal };
    setChildList(newArray);
    handleChange(newArray);
  };
  const firstNameChange = (val, i) => {
    let newArray = [...childList];
    newArray[i] = {
      ...newArray[i],
      firstName: formatName(val).replaceAll(/\s/g, ""),
    };
    setChildList(newArray);
    handleChange(newArray);
  };
  const lastNameChange = (val, i) => {
    let newArray = [...childList];
    newArray[i] = { ...newArray[i], lastName: formatName(val) };
    setChildList(newArray);
    handleChange(newArray);
  };
  const birthDateChange = (val, i) => {
    let newArray = [...childList];
    let dateFormat = moment(val).format("YYYYMMDD");
    if (dateFormat !== "Invalid date" && !isMobile) {
      newArray[i] = {
        ...newArray[i],
        birthDate:
          val.getFullYear() >= year - 20 && val.getFullYear() <= year
            ? dateFormat
            : "",
      };
    } else {
      newArray[i] = {
        ...newArray[i],
        birthDate: isMobile ? dateFormat : "",
      };
    }
    setChildList(newArray);
    handleChange(newArray);
  };
  const addChild = () => {
    let addArray = [...childList];
    addArray.push({
      cardId: "",
      firstName: "",
      lastName: "",
      birthDate: "",
    });
    setChildList(addArray);
    handleChange(addArray);
  };
  const deleteChild = (i) => {
    let addArray = [...childList];
    if (addArray.length > 1) {
      addArray.splice(i, 1);
      setChildList(addArray);
      handleChange(addArray);
    }
  };
  return (
    <Grid className="pb-4">
      <Typography className="font-title">ข้อมูลบุตร</Typography>
      {childList.map((row, i) => (
        <Grid className=" pt-3 pr-3" key={i}>
          <Typography
            className={clsx(classes.typographyBtnCancel, "font-title")}
          >
            บุตรคนที่ {i + 1}{" "}
            <CancelIcon
              style={{ display: i === 0 ? "none" : "block" }}
              onClick={(e) => deleteChild(i)}
            />
          </Typography>
          <Grid className="input-form">
            <FormControl variant="standard" fullWidth error>
              <TextField
                fullWidth
                className={"font-20"}
                label="เลขที่บัตรประจำตัวประชาชน"
                variant="standard"
                value={formatterIdCard(row?.cardId)}
                onChange={(e) => cardIdChange(e.target.value, i)}
                required
                type="tel"
              />
            </FormControl>
            <FormHelperText className="text-error">
              {valid ? CardIdError(row?.cardId) : ""}
            </FormHelperText>
          </Grid>
          <Grid className="input-form">
            <FormControl variant="standard" fullWidth error>
              <TextField
                fullWidth
                className={"font-20"}
                label="ชื่อ"
                variant="standard"
                value={row?.firstName}
                onChange={(e) => firstNameChange(e.target.value, i)}
                required
              />
            </FormControl>
            <FormHelperText className="text-error">
              {valid && checkValidate(row?.firstName) ? "กรุณากรอกชื่อ" : ""}
            </FormHelperText>
          </Grid>
          <Grid className="input-form">
            <FormControl variant="standard" fullWidth error>
              <TextField
                fullWidth
                className={"font-20"}
                label="นามสกุล"
                variant="standard"
                value={row?.lastName}
                onChange={(e) => lastNameChange(e.target.value, i)}
                onBlur={(e) => lastNameChange(e.target.value.trim(), i)}
                required
              />
            </FormControl>
            <FormHelperText className="text-error">
              {valid && checkValidate(row?.lastName) ? "กรุณากรอกนามสกุล" : ""}
            </FormHelperText>
          </Grid>
          <Grid className="input-form">
            <FormControl variant="standard" fullWidth error>
              {!isMobile ? (
                <DesktopDatePickerComponent
                  id="birthday"
                  label="วันเดือนปีเกิด (ค.ศ.)"
                  value={row?.birthDate ? moment(row?.birthDate, 'YYYYMMDD').toDate() : null}
                  minDate={new Date(year - 20, month, day)}
                  maxDate={new Date(year, month, day)}
                  onChange={(e) => birthDateChange(e, i)}
                  required={true}
                />
                // <LocalizationProvider
                //   dateAdapter={AdapterDateFns}
                //   locale={localeMap[lang]}
                // >
                //   <DatePicker
                //     value={
                //       row?.birthDate ? formatterDate(row?.birthDate) : null
                //     }
                //     minDate={new Date(year - 20, month, day)}
                //     maxDate={new Date(year, month, day)}
                //     onChange={(e) => birthDateChange(e, i)}
                //     renderInput={(params) => (
                //       <TextField
                //         {...params}
                //         className="font-20"
                //         required
                //         label="วันเดือนปีเกิด (ค.ศ.)"
                //         variant="standard"
                //       />
                //     )}
                //   />
                // </LocalizationProvider>
              ) : (
                <>
                  <Grid>
                    <Typography className="text-primary font-16 font-normal">
                      วันเดือนปีเกิด (ค.ศ.)*
                    </Typography>
                    <Grid className="date-idc-mb">
                      <DatePickerInput
                        value={
                          row?.birthDate
                            ? moment(row.birthDate).format("YYYYMMDD")
                            : ""
                        }
                        minDate={new Date(year - 20, month, day)}
                        maxDate={new Date(year, month, day)}
                        onSelected={(e) => birthDateChange(e, i)}
                      />
                      <EventIcon className="icon-date" />
                    </Grid>
                  </Grid>
                </>
              )}
              <FormHelperText className="text-right">
                {valid && checkValidate(row?.birthDate)
                  ? "กรุณากรอกวันเดือนปีเกิด"
                  : ""}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      ))}
      {childList.length < 4 && (
        <Button
          className={clsx(classes.btnChild, "font-20")}
          onClick={addChild}
        >
          <AddIcon /> เพิ่มข้อมูลบุตร
        </Button>
      )}
    </Grid>
  );
};

export default memo(ChildList);
